import { render, staticRenderFns } from "./DHZ.vue?vue&type=template&id=05d5c96e&scoped=true"
import script from "./DHZ.vue?vue&type=script&lang=js"
export * from "./DHZ.vue?vue&type=script&lang=js"
import style0 from "./DHZ.vue?vue&type=style&index=0&id=05d5c96e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05d5c96e",
  null
  
)

export default component.exports